import ResponseStatus from "./api";

/**
 * Reversed renewal feature constants
 *
 * Reversed renewal occurs when order has:
 * - status = "REVERSED"
 * - subscriptionBillingCycle.billingCycle > 1
 */

/** Feature flag - set to false to disable feature */
export const REVERSED_RENEWAL_ENABLED = true;

/** Order status that indicates reversed payment */
export const REVERSED_RENEWAL_STATUS = ResponseStatus.REVERSED;

/** Minimum billing cycle to trigger renewal */
export const REVERSED_RENEWAL_MIN_CYCLE = 1;

/** Debug label for logging */
export const REVERSED_RENEWAL_DEBUG_LABEL = "ReversedRenewal";

export const ReversedRenewalConstants = {
  ENABLED: REVERSED_RENEWAL_ENABLED,
  STATUS: REVERSED_RENEWAL_STATUS,
  MIN_CYCLE: REVERSED_RENEWAL_MIN_CYCLE,
  DEBUG_LABEL: REVERSED_RENEWAL_DEBUG_LABEL,
} as const;

export default ReversedRenewalConstants;
